<template>
	<v-card outlined>
		<v-card-title
			v-text="'Locals'"
			class="justify-center body-1 primary pa-1"
		>			
		</v-card-title>
		<v-card-text>
			<input_table
				:info_table="info_to_table"
				:list_table="list_to_table"				
			></input_table>
		</v-card-text>
	</v-card>
</template>
<script>
import input_table from '@/components/info/input_table.vue'
	export default{
		name: 'locals',
		components:{
			input_table
		}, // components
		props: [ 'info_module' ],
		data: (vm) => ({
			info_to_table: null,
			headers_modules:[				
				{ text: vm.$ml.get('name') , value: 'name', align: ''},
				{ text: 'Content', value: 'content', align: '' }, 
				// { text: 'Enable', value: 'enable', align: '' },
			], // headers
			list_to_table: [
				{
					name: 'Dasboard',
					module: 'dashboard',
					enable: true,
					icon: 'mdi-view-dashboard',
					roles: [1 , 2, 3], 
				},
				{ 	
					name: 'LPR',				
					module: 'lpr',
					enable: true,
				    icon: 'mdi-card-text',		        
				    roles: [1 , 2, 3], 
				    sub_modules: 
			          	[
			          		/*{
				              name: '', // identific
				              sub_module: '', // path
				              title: '', //
				              icon: ''
				            },*/
			            	{
				              name: 'lpr',
				              sub_module: 'dashboard_lpr',
				              title: 'dashboard',
				              icon: 'mdi-post-outline',
				              
				            },
				            {
				              name: 'Reports',
				              sub_module: 'reports', 
				              title: 'reports',
				              icon: 'mdi-file-chart'				              
				            },
				            
				        ]
				},
				

			], // list to table
		}), // data
		created(){
			this.info_to_table={
				headers: this.headers_modules,
				total: 6,
				options: { itemsPerPage: 30 },
			}

			this.render_info();
		}, // created

		methods: {
			render_info(){
				let info_local = window.localStorage;
				let list = [];
				let arr_local = Object.entries(info_local); //  /values / keys / entries
				// console.log(info_local, "info_local");
				arr_local.forEach(function (item_local, idx_local){
					// console.log(item_local, idx_local  )
					if(item_local && item_local.length > 0){			
						let content_temp = (item_local[1]);
						list.push({
							name: item_local[0],
							content: content_temp
						})
					}
				
				})

				this.list_to_table = list;

			},
		}, // methods

		mounted(){
			this.$emit('info_from_component', this.list_to_table);
		}, // mounted
	};
</script>